/**
 * The Question Bank Management mark — a review board: three columns of cards, the
 * middle one solid. BRANDING §10.
 *
 * Drawn in `currentColor`, never a literal, so the tile that hosts it decides the
 * contrast in both palettes (`text-bank-on-brand` on `bg-bank-brand`). The static copy
 * for the favicon lives in `public/brand/logo.svg` and must be kept geometrically in
 * step with this one.
 */
import { cn } from "@/lib/utils";

const CARDS = [
  { x: 9, y: 10, opacity: 0.55 },
  { x: 9, y: 26, opacity: 0.55 },
  { x: 25.5, y: 10, opacity: 1 },
  { x: 25.5, y: 26, opacity: 1 },
  { x: 25.5, y: 42, opacity: 1 },
  { x: 42, y: 10, opacity: 0.3 },
] as const;

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      // Cropped to the glyph's own extent so a small tile is not mostly padding.
      viewBox="8 8 48 48"
      fill="currentColor"
      aria-hidden="true"
      className={cn("select-none", className)}
    >
      {CARDS.map(({ x, y, opacity }) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={13} height={12} rx={3.5} opacity={opacity} />
      ))}
    </svg>
  );
}
